import React from 'react';
import {
  ComponentParams,
  ComponentRendering,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps } from './shared.types';

interface Props {
  rendering?: (ComponentRendering & { params?: ComponentParams }) | RenderingProps['rendering'];
  fieldName?: string;
}

export const PromptForMissingDatasource = (props?: Props): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (isEditing) {
    return <h3>Datasource for rendering {props?.rendering?.componentName} is not set</h3>;
  }

  return <></>;
};

export const PromptForMissingFieldValue = (props?: Props): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (isEditing) {
    return (
      <h3>
        Required &quot;{props?.fieldName}&quot; field on rendering {props?.rendering?.componentName}{' '}
        is not set
      </h3>
    );
  }

  return <></>;
};
